import React, { useState } from "react";
import { Transformer, Image } from "react-konva";

const AdditionalImageLayer: React.FC<{
  imageSrc: any;
  ImgClicked: any;
  canvasWidth: number;
  canvasHeight: number;
}> = ({ imageSrc, ImgClicked, canvasWidth, canvasHeight }) => {
  //構成要素、クリックされているか,ImageSrc,Image,Image変換
  // imgsrc,clicked=>上管理

  const [useImg, setImg]: any = useState(); //画像入れるとこ
  const AddImgRef: any = React.useRef();
  const [AddImgAxis, setAddImgAxis] = React.useState({ x: 360, y: 160 });

  const trRef: any = React.useRef(); //trで横ひっぱるとまずいことになる->前バージョンのBCGと比較すること

  React.useEffect(() => {
    //画像反映用 srcを引数から持ってきてsetStateする。
    const tempImg = document.createElement("img");
    tempImg.src = imageSrc;
    tempImg.onload = () => {
      const rawWidth = tempImg.width;
      tempImg.width = canvasWidth / 3.2;
      tempImg.height = tempImg.height * (canvasWidth / 3.2 / rawWidth);
      setImg(tempImg);
    };
    if (ImgClicked !== false) {
      trRef.current.nodes([AddImgRef.current]);
      trRef.current.getLayer().batchDraw();
    }
  }, [imageSrc, ImgClicked, canvasWidth]);

  React.useEffect(() => {
    //クリックしてるオブジェクトが変更されたとき発火。
    if (ImgClicked !== false) {
      trRef.current.nodes([AddImgRef.current]);
      trRef.current.getLayer().batchDraw();
    }
  }, [ImgClicked]);

  React.useEffect(() => {
    //キャンバスサイズ変更によるサイズ再計算
    const tempImg = document.createElement("img");
    tempImg.src = imageSrc;
    tempImg.onload = () => {
      const rawWidth = tempImg.width;
      tempImg.width = canvasWidth / 3.2;
      tempImg.height = tempImg.height * (canvasWidth / 3.2 / rawWidth);
      setImg(tempImg);
    };
  }, [canvasWidth, imageSrc]);

  const handleDragEnd = (e: any) => {
    setAddImgAxis({
      x: e.target.x(),
      y: e.target.y(),
    });
  };

  //image->
  return (
    <>
      <Image
        image={useImg}
        draggable={true}
        onDragEnd={handleDragEnd}
        ref={AddImgRef}
        width={canvasWidth / 3.2}
        x={canvasWidth / 1.68}
        y={canvasHeight / 2.25}
      ></Image>
      {ImgClicked && (
        <Transformer
          ref={trRef} //この辺解決したい
          enabledAnchors={[
            "top-left",
            "top-right",
            "bottom-left",
            "bottom-right",
          ]}
          keepRatio={true}
        ></Transformer>
      )}
    </>
  );
};

export default AdditionalImageLayer;
